"use strict";
var PromiseObservable_1 = require('./PromiseObservable');
exports.fromPromise = PromiseObservable_1.PromiseObservable.create;
//# sourceMappingURL=fromPromise.js.map


//////////////////
// WEBPACK FOOTER
// /Users/Dan/Documents/PoC/angular-giaa/~/rxjs/observable/fromPromise.js
// module id = ../../../../rxjs/observable/fromPromise.js
// module chunks = 4